module.exports = __webpack_public_path__ + "img/new-empty-workgroup.72ca7003.svg";